import React, { Component } from 'react'
import * as dataActions from './actions/dataActions'
import * as sessionActions from './actions/sessionActions'

import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'

import NavBar from './components/Navbar'

import './styles/base.css'
import './styles/fonts.css'

class App extends Component {
  componentWillMount () {
    this.props.sessionActions.persistUser()
  }

  render () {
    return (
      <NavBar />
    )
  }
}

function mapDispatchToProps (dispatch) {
  return {
    dataActions: bindActionCreators(dataActions, dispatch),
    sessionActions: bindActionCreators(sessionActions, dispatch)
  }
}

export default connect(null, mapDispatchToProps)(App)



// WEBPACK FOOTER //
// ./src/App.js